<template>
  <div class="journey-group">
    <!-- FILTERS -->
    <div class="mt-1 mb-5" :class="pathMixin_isMeeting ? 'box' : ''"></div>
    <FlightFilters
      v-if="Object.keys(filterOptions).length > 0"
      :config="filterConfig"
      @updateSort="(order) => (sortOrder = order)"
    />

    <!-- SELECTED FLIGHT BOX -->
    <div v-if="selectedIdsCount > 0" class="mb-5 is-hidden-touch">
      <div
        v-for="(selected) in selectedIds"
        :key="selected.segmentIndex"
        data-test="selected_result_container"
      >
        <h3 class="is-size-6 mb-4 is-uppercase has-text-weight-bold">
           {{ journeyLabel(selected.segmentIndex) }} Flight Selected
        </h3>

        <JourneyGroupItem
          :key="selected.uniqueKey"
          :journey="findJourney(selected.uniqueKey, selected.segmentIndex)"
          :itineraryPrices="itineraryPrices"
          :rawItems="items"
          :preferredVendors="preferredVendors"
        />
      </div>
    
    </div>

    <h3 class="is-size-6 mb-4 is-uppercase has-text-weight-bold">
      {{ journeyLabel(segmentIndex+1) }} flights
    </h3>


    <!-- INFO ICONS (Legend) -->
    <div class="mb-2 pb-1 is-flex is-justify-content-center">
      <span class="ml-2 mr-2" v-if="$globals.ticketAirlines.length > 0">
        <b-icon icon="currency-usd" size="is-default" type="is-info"></b-icon>
        <span class="is-size-7 has-text-grey" style="margin-left: -5px;">
          = Unused Ticket Available</span
        >
      </span>
      <span class="ml-2 mr-2" v-if="isOneWayFlight">
        <b-icon
          icon="alpha-f-circle"
          size="is-default"
          class="has-text-grey-lighter"
        />
        <span class="is-size-7 has-text-grey"> = Fare Rules</span>
      </span>
      <!--        <span class="ml-2 mr-2">-->
      <!--          <b-icon-->
      <!--                  icon="information"-->
      <!--                  size="is-default"-->
      <!--                  class="has-text-grey-lighter"-->
      <!--              />-->
      <!--          <span class="is-size-7 has-text-grey">Flight Details</span>-->
      <!--        </span>-->
    </div>

    <!--  HEADERS -->
    <div
      class="columns is-mobile is-gapless mb-0 pr-1 filters-container is-hidden-touch"
    >
      <!-- AIRLINE LOGO -->
      <div class="column is-narrow has-text-centered wrap">
        <div class="mt-1 airlineLogo"></div>
      </div>
      <!-- FROM-TO -->
      <div class="column is-narrow" style="width:150px">
        <span class="sbs-table-header">From-To</span>
      </div>
      <!-- DEPARTURE-ARRIVAl -->
      <div class="column is-narrow" style="width:200px">
        <span class="sbs-table-header">Departure-Arrival</span>
      </div>
      <!-- DURATION -->
      <div class="column has-text-left">
        <span class="sbs-table-header">Duration & Stops</span>
      </div>
      <!-- UNUSED TICKET -->
      <div class="column has-text-centered is-narrow" style="width:40px;">
        <span class="sbs-table-header" v-if="$globals.ticketAirlines.length > 0"
          >$</span
        >
      </div>
      <!-- PRICE RANGE -->
      <div
        class="column is-narrow mr-2"
        style="width:120px"
        :class="'has-text-right'"
      >
        <span v-if="useAtcShopper" class="sbs-table-header ml-3"
          >Total Due</span
        >
        <span v-else class="sbs-table-header ml-3">Price Range</span>
      </div>
      <div v-if="useAtcShopper" class="column is-narrow mr-2">
        <span class="sbs-table-header ml-3">Residual Value</span>
      </div>
      <!-- FARE RULES (One-Way Only) -->
      <div
        class="column is-narrow has-text-left"
        v-if="isOneWayFlight"
        style="width:40px;"
      >
        <span class="sbs-table-header">
          Fare
        </span>
      </div>
      <!-- FLIGHT INFO -->
      <div class="column is-narrow" style="width: 100px;"></div>
      <!-- SELECT/DESELECT BUTTONS -->
      <div class="column is-narrow mr-2" style="width: 70px;"></div>
    </div>

    <FilterWarningNotification v-if="showFilterWarning" />

    <div v-if="loading" class="py-2">
      <ResultSkele v-for="(skeleton, index) in 3" :key="index" />
    </div>
    <div
      v-else
      class="flightResultsContainer"
      data-test="sbs_results_container"
    >
      <JourneyGroupItem
        v-for="item in visibleSortedJourneys"
        :key="item.uniqueKey"
        :journey="item"
        :raw-items="items"
        :preferredVendors="preferredVendors"
        :isOneWayFlight="isOneWayFlight"
      />

      <div class="has-text-centered">
        <b-button
          v-if="numVisibleResults < sortedJourneys.length"
          outlined
          type="is-info"
          size="is-medium"
          class="mt-4 mb-4 air_show_more_results_btn"
          @click="numVisibleResults += pageSize"
          >Show more results</b-button
        >
      </div>

      <!-- LOADING MESSAGE -->
      <div v-if="segmentIndex == 2" class="mt-5">
        <div
          v-if="$store.state.bookTravel.moreResultsLoadingStatus"
          class="pt-1 pb-2 pr-0"
        >
          <b-message type="is-info" class="has-text-centered">
            <span class="gant-text"
              >Please wait while we're searching for additional flights.
            </span>
            <ReloadIcon style="width: 30px;" />
          </b-message>
        </div>
      </div>

      <!-- MORE RESULTS LOADER BELOW -->
      <MoreFlightResultsLoader
        :filterOptions="moreResultsFilterOptions"
        @searchTargetedAirlines="searchTargetedAirlines"
      />
      <!-- END MORE RESULTS LOADER -->
    </div>
  </div>
</template>

<script>
import bookingMixin from "@/mixins/bookingMixin"
import { mapState } from "vuex"
let moment = require("moment")
import JourneyGroupItem from "./JourneyGroupItem.vue"
import FlightFilters from "@/components/Filters/FlightFilters.vue"
import ReloadIcon from "/public/images/SVGs/Reload-1s-200px.svg"
import MoreFlightResultsLoader from "@/components/BookTravel/Air/MoreFlightResultsLoader"
import ResultSkele from "@/components/SkeletonLoaders/ResultSkele.vue"
import FilterWarningNotification from "./FilterWarningNotification.vue"

export default {
  components: {
    JourneyGroupItem,
    FlightFilters,
    MoreFlightResultsLoader,
    FilterWarningNotification,
    ReloadIcon,
    ResultSkele,
  },
  mixins: [bookingMixin],
  props: {
    segmentIndex: null,
    items: Array,
    tripVal: Number,
    journeys: Array,
    itineraryPrices: Array,
    isOneWayFlight: Boolean,
    currencyCode: String,
  },
  data() {
    return {
      selectedLegCounts: [],
      sortOrder: "earliestDeparture",
      numVisibleResults: 20,
      pageSize: 20,
    }
  },
  watch: {},
  computed: {
    ...mapState(["bookTravel"]),
    filters() {
      return this.$store.state.flight.filters
    },
    filterConfig() {
      return {
        filterOptions: this.filterOptions,
        preferredVendors: this.preferredVendors,
        sortOrder: this.sortOrder,
        sortOptions: this.sortOptions,
        unusedTickets: this.unusedTickets,
        tripVal: this.tripVal,
        currencyCode: this.currencyCode,
      }
    },
    filterOptions() {
      const options = this.$store.state.flight.filterOptions
      return {
        allAirlines: options.allAirlines,
        filteredAirlines: options.filteredAirlines,
        unusedTickets: this.unusedTickets,
        stops: options.stops,
        times: null,
        tripVal: this.tripVal,
        priceData: options.priceData,
        availablePolicies: options.availablePolicies,
        highestRating: null,
        ndc: options.ndc,
      }
    },
    //filter options for the More Results loader
    moreResultsFilterOptions() {
      const options = {
        allAirlines: this.filterOptions.allAirlines,
        filteredAirlines: this.filterOptions.filteredAirlines,
        unusedTickets: null,
        stops: null,
        times: null,
        tripVal: this.filterOptions.tripVal,
        priceData: null,
        availablePolicies: null,
        highestRating: null,
        ndc: null,
      }

      return options
    },
    isOneWay() {
      return (
        this.$store.getters["bookTravel/getExpectedUnbundledJourneysCount"] ===
        1
      );
    },

    selectedIdsCount() {
      return this.selectedIds.length
    },

    //filter doesnt work here -- i need to preseve the index so the the findJourney function can find the correct journey
    //list containing selected journeys not including the current segment
    selectedIds() {
      //return this.bookTravel.selectedUnbundledJourneys.map((journey, i) => i === this.segmentIndex ? null : journey);
      return this.bookTravel.selectedUnbundledJourneys.filter((journey) => journey.segmentIndex-1 !== this.segmentIndex );
    },

    visibleSortedJourneys() {
      return this.sortedJourneys.slice(0, this.numVisibleResults)
    },

    sortedJourneys() {
      const sortedJourneys = [...this.journeys]

      if (this.sortOrder == "earliestDeparture") {
        sortedJourneys.sort((a, b) => {
          var dateA = moment(a.startDate + "T" + a.startTime)
          var dateB = moment(b.startDate + "T" + b.startTime)
          return dateA - dateB
        })
      } else if (this.sortOrder == "earliestArrival") {
        sortedJourneys.sort((a, b) => {
          var dateA = moment(a.endDate + "T" + a.endTime)
          var dateB = moment(b.endDate + "T" + b.endTime)
          return dateA - dateB
        })
      } else if (this.sortOrder == "duration") {
        sortedJourneys.sort((a, b) => a.travelDuration - b.travelDuration)
      } else if (this.sortOrder == "priceDESC") {
        sortedJourneys.sort((a, b) => a.pricing.total - b.pricing.total)
      } else if (this.sortOrder == "priceASC") {
        sortedJourneys.sort((a, b) => b.pricing.total - a.pricing.total)
      } else if (this.sortOrder == "Preferred Vendors") {
        sortedJourneys.sort((a, b) => {
          return this.preferredVendors.includes(a.airlineCode)
            ? -1
            : this.preferredVendors.includes(b.airlineCode)
            ? 1
            : 0
        })
      }

      return sortedJourneys
    },

    sortOptions() {
      let options = [
        { value: "earliestDeparture", label: "Departure Time" },
        { value: "earliestArrival", label: "Arrival Time" },
        { value: "Duration", label: "Duration" },
      ]

      if (this.preferredVendors.length > 0) {
        options.push({
          value: "Preferred Vendors",
          label: "Preferred Airlines",
        })
      }

      return options
    },

    unusedTickets() {
      return this.$store.getters["travellersAndTrips/getCurrentTravellerProfile"].unusedTicketAirlines
    },
    profile() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ]
    },
    preferredVendors() {
      return this.profile.preferredAirVendors || []
    },
    useAtcShopper() {
      return this.$store.state.bookTravel.atc?.useAtcShopper
    },
    loading: {
      get() {
        return this.$store.state.bookTravel.searchLoadingStatus
      },
      set(value) {
        this.$store.commit("bookTravel/FLIGHT_SEARCH_LOADING_STATUS", value)
      },
    },
    showFilterWarning: {
      get() {
        return this.$store.state.flight.showFilterWarning
      },
      set(value) {
        this.$store.commit("flight/SET_FILTER_WARNING", value)
      },
    },
  },
  methods: {
  
    findJourney(uniqueKey, segmentIndex) {

      //console.log("uniqueKey: ", uniqueKey)
      //console.log("index: ", segmentIndex)

      const items = this.items
      // Check if items is an array
      if (!Array.isArray(items)) {
        return null
      }

      // Iterate through each item
      for (const item of items) {
        // Check if item has journeys array
        if (item && Array.isArray(item.journeys)) {
          // Look for matching journey within this item
          const journey = item.journeys.find(
            (journey) =>
              journey.segmentIndex === segmentIndex &&
              journey.uniqueKey === uniqueKey
          )

          // If found, return the journey
          if (journey) {
            return journey
          }
        }
      }

      // If no matching journey is found in any item
      return null
    },

    journeyLabel(index) {
        return index == 1
          ? "Outbound"
          : index == 2
          ? "Return"
          : "Segment " + index 
      
    },

    searchTargetedAirlines(targetedAirlines) {
      //this.$store.commit("bookTravel/FLIGHT_SEARCH_LOADING_STATUS", true);

      //reduce array of objects to simple array of airline codes
      //let targetedAirlines = targetedAirlinesObj.map((a) => a.code);

      this.$emit("searchTargetedAirlines", targetedAirlines)
    },
  },
  created() {
    this.TRIP_ONE_WAY = 0
    this.TRIP_ROUNDTRIP = 1
    this.TRIP_MULTI_CITY = 2
    this.ARRIVAL_TIME = 1
    this.DEPARTURE_TIME = 0
  },
  mounted() {},
}
</script>

<style scoped></style>
